module.exports = __webpack_public_path__ + "img/rsz_img_20210505_183444.121a59cf.jpg";